<app-modal #modal>
  <h3 translate="INCLUDE_MODALUSERAPI_TITLE_CONNECT" [translateParams]="{ api: userApi.api.name }"></h3>

  <form>
    @if (userApi.api.configType === 'AFAS') {
      <app-userapi-afas [userApi]="userApi"></app-userapi-afas>
    } @else if (userApi.api.configType === 'API_ENDPOINT_WITH_KEYS') {
      <app-userapi-api-endpoint-with-keys [userApi]="userApi"></app-userapi-api-endpoint-with-keys>
    } @else if (userApi.api.configType === 'API_ENDPOINT_WITH_TOKEN') {
      <app-userapi-api-endpoint-with-token [userApi]="userApi"></app-userapi-api-endpoint-with-token>
    } @else if (userApi.api.configType === 'OAUTH' || userApi.api.configType === 'OAUTH_SNELSTART') {
      <app-userapi-oauth [userApi]="userApi"></app-userapi-oauth>
    } @else if (userApi.api.configType === 'OAUTH_WITH_CUSTOM_URL') {
      @if (userApi.api.internalKey === 'ExactOnline') {
        <app-userapi-exactonline [userApi]="userApi"></app-userapi-exactonline>
      } @else if (userApi.api.internalKey === 'Zoho') {
        <app-userapi-zoho [userApi]="userApi"></app-userapi-zoho>
      } @else if (userApi.api.internalKey === 'SageActive') {
        <app-userapi-sageactive [userApi]="userApi"></app-userapi-sageactive>
      } @else {
        <app-userapi-oauth-with-custom-url [userApi]="userApi"></app-userapi-oauth-with-custom-url>
      }
    } @else if (userApi.api.configType === 'OAUTH_WITH_CUSTOM_URL_ANDKEYS') {
      <app-userapi-oauth-with-custom-url-and-keys [userApi]="userApi"></app-userapi-oauth-with-custom-url-and-keys>
    } @else if (userApi.api.configType === 'PUBLIC_PRIVATE_KEY') {
      <app-userapi-public-private-key [userApi]="userApi"></app-userapi-public-private-key>
    } @else if (userApi.api.configType === 'SINGLE_KEY' || userApi.api.configType === 'SINGLE_KEY_CUSTOM_URL') {
      <app-userapi-single-key [userApi]="userApi"></app-userapi-single-key>
    } @else if (userApi.api.configType === 'RABOBANK') {
      <app-userapi-rabobank [userApi]="userApi"></app-userapi-rabobank>
    } @else if (userApi.api.configType === 'TRIPLE_KEY') {
      <app-userapi-triple-key [userApi]="userApi"></app-userapi-triple-key>
    } @else if (userApi.api.configType === 'USERNAME_PASSWORD' || userApi.api.configType === 'USERNAME_PASSWORD_CUSTOM_URL' || userApi.api.configType === 'USERNAME_PASSWORD_WITH_CUSTOM_PARAM') {
      <app-userapi-username-password [userApi]="userApi"></app-userapi-username-password>
    }
  </form>
</app-modal>
